export const loginApiEndPoints  = (token,tenantCode, myOrgName,baseUrl) => [
  // 1. Get Organisation by Subdomain
  {
    name: "Get Organisation By Subdomain",
    path: `${baseUrl}/gateway/master/Organisation/by/subdomain?subdomain=${myOrgName}`,
    methods: ["GET"],
    description: "Get tenant code by org subdomain (required for login).",
    queryParameters: [
      {
        name: "subdomain",
        description: "Organisation subdomain.",
        type: "string",
        required: true,
        example: "simplisys"
      }
    ],
    headers: [
      // add more headers if needed
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          tenantCode: tenantCode
        }
      },
      error: {
        status: 404,
        data: {
          error: "Not found",
          message: "Organisation for subdomain not found"
        }
      }
    }
  },
  // 2. User Login
  {
    name: "User Login",
    path: `${baseUrl}/gateway/common/Login`,
    methods: ["POST"],
    description: "Authenticate user and receive a JWT token.",
    headers: [
      { key: "Content-Type", value: "application/json", enabled: true }
      // tenant-code is normally a header, but your markdown shows it in body, choose depending on your API!
    ],
    requestBody: {
      email: "user@example.com",
      password: "securePassword123",
      RECAPTCHA_TOKEN: "RECAPTCHA_TOKEN",
      tenantCode: tenantCode
    },
    parameters: [
      {
        name: "email",
        description: "User's registered email address.",
        type: "string",
        required: true
      },
      {
        name: "password",
        description: "User's password.",
        type: "string",
        required: true
      },
      {
        name: "RECAPTCHA_TOKEN",
        description: "Google reCAPTCHA token to prevent bots.",
        type: "string",
        required: false
      },
      {
        name: "tenantCode",
        description: "Tenant code retrieved from the organisation API.",
        type: "string",
        required: true
      }
    ],
    responses: {
      success: {
        status: 200,
        data: {
          token: token
        }
      },
      error: {
        status: 401,
        data: {
          error: "Invalid credentials",
          message: "Username or password is incorrect"
        }
      }
    }
  }
];

export const ticketNotificationsapiendpoints = (token,tenantCode, myOrgName,baseUrl) => [
  {
    name: "Get Ticket Notifications",
    path: `${baseUrl}/gateway/TicketNotification/?page=1&count=5`,
    methods: ["GET"],
    description: "Retrieve a paginated list of ticket notifications.",
    headers: [
      { key: 'tenant-code', value: 'vizionsys', enabled: true },
      { key: 'Content-Encrypted', value: 'true', enabled: true },
      { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "page",
        description: "The result page to fetch.",
        type: "number",
        required: true,
        example: 1
      },
      {
        name: "count",
        description: "Number of records per page.",
        type: "number",
        required: true,
        example: 75
      }
    ],
    queryParameters: [
      {
        name: "page",
        description: "The result page to fetch.",
        type: "number",
        required: true,
        example: 1
      },
      {
        name: "count",
        description: "Number of records per page.",
        type: "number",
        required: true,
        example: 75
      }
    ],
    requestBody: {}, // No body for GET
    responses: {
      success: {
        status: 200,
        data: {
          page: 1,
          count: 75,
          total: 150,
          notifications: [
            {
              id: 12345,
              ticketId: 6789,
              message: "Ticket updated",
              createdAt: "2024-05-23T10:31:42Z",
              read: false
            }
            // ...additional notifications
          ]
        }
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];


export const SubscriptionAapiendpoints = (token,tenantCode, myOrgName,baseUrl) => [
  {
    name: "Get Subscriptions",
    path: `${baseUrl}/gateway/subscription`,
    methods: ["GET"],
    description: "Retrieve a list of all subscriptions available for the specified tenant.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: 'Authorization', value: `Bearer ${token}`, enabled: true }

    ],
    parameters: [
      // No additional query or path parameters for this endpoint
    ],
    requestBody: {}, // No body required for GET
    responses: {
      success: {
        status: 200,
        data: {
          subscriptions: [
            {
              id: 1,
              planName: "Pro",
              status: "Active",
              startDate: "2024-01-01",
              endDate: "2025-01-01",
              features: [
                "Unlimited Tickets",
                "Priority Support"
              ]
            }
            // ... more subscription objects
          ]
        }
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Missing or invalid tenant-code"
        }
      }
    }
  }
];

export const getAgentByTokenapiendpoints = (token,tenantCode, myOrgName,baseUrl) => [
  {
    name: "Get Agent By Token (v2)",
    path: `${baseUrl}/gateway/Agent/by/token/v2`,
    methods: ["GET"],
    description: "Retrieve agent profile information based on the provided Bearer token.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: 'Authorization', value: `Bearer ${token,tenantCode, myOrgName}`, enabled: true }

    ],
    parameters: [],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          "agent": {
            "id": 1,
            "firstName": "Amith",
            "lastName": "Malipatil",
            "userName": "vizion123",
            "agentTypeId": 0,
            "agentAvatarPath": `${baseUrl}/gateway/imagedetails/vizionsys/Agent/1/vizion123.jpg`,
            "mobilePhone": "",
            "email": null,
            "isAdmin": false,
            "isActive": true,
            "roleId": 1,
            "appDeviceId": null,
            "webDeviceId": "fIgpOFHGTEugQJHliBuxTF:APA91bGtdKpr9QhrPmvvuIlgjayf5m96qDNOmoIq2VMedYQBYyuyIrMyAu3X0ABs3bU79hQUvcvLRxqfAVF95xbmWoYrP1ywFY6QZ3ATAQ8OKS1y_Ku-vLE",
            "language": "",
            "agentDescription": null,
            "accountStatus": "Completed",
            "createdAt": "2025-01-03T07:12:59.249021",
            "updatedAt": "2025-07-16T14:07:33.751756",
            "isTwoFactorEnabled": false,
            "isTwoFactorSetupCompleted": false,
            "agentAvatarId": 0,
            "licenseKeyId": 1,
            "agentPreferences": "{\"theme\": \"light-mode\",\"view\": \"Status\"}",
            "userGroupList": [
              {
                "id": 620370,
                "userId": 1,
                "groupId": 1,
                "isDefault": true,
                "isActive": true,
                "agent": null
              }
            ],
            "password": null,
            "roles": {
              "id": 1,
              "name": "SuperAdmin",
              "description": "SuperAdmin",
              "isActive": true,
              "isSuperAdmin": true,
              "isSSPRole": false,
              "agentPermissionsList": []
            },
            "agentLoginSession": null
          },
          "organisation": {
            "id": 1,
            "name": "Vizionsys",
            "email": "amith.malipatil404@gmail.com",
            "mobile": "9980878194",
            "editionId": 3,
            "totalNumberOfAgents": 22,
            "licenseStartDate": "2024-05-20T09:24:32.991978",
            "licenseEndDate": "2025-06-20T09:24:32.991978",
            "createdAt": "2024-01-10T09:01:27.745163",
            "updatedAt": "2024-09-26T12:23:47.163137",
            "isActive": true,
            "isYearly": false,
            "isMonthly": true,
            "country": "INDIA",
            "organisationAvatarId": 9748,
            "organisationAvatarPath": `${baseUrl}/gateway/imagedetails/webasserts/vizionsys.png`,
            "subdomain": "simplisys.vizionsys.com",
            "location": null,
            "primaryAgent": null,
            "organisationCoreProduct": null,
            "organisationUrl": null
          },
          "organisationSetting": {
            "id": 1,
            "isTwoFactorEnabled": false,
            "dateFormat": "en-gb",
            "createdAt": "2024-01-10T09:01:22.445784",
            "updatedAt": "2024-01-10T09:01:22.445784"
          }
        }
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or expired Bearer token"
        }
      }
    }
  }
];


export const agentroleapiendpoints = (token,tenantCode, myOrgName,baseUrl) => [
  {
    name: "Get Role By ID",
    path: `${baseUrl}/gateway/Role/1`, // Use :id for param if dynamic
    methods: ["GET"],
    description: "Retrieve details of a specific role by its ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: 'Authorization', value: `Bearer ${token}`, enabled: true }

    ],
    parameters: [
      {
        name: "id",
        description: "Role ID",
        type: "number",
        required: true,
        example: 1
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          "id": 1,
          "name": "SuperAdmin",
          "description": "SuperAdmin",
          "isActive": true,
          "isSuperAdmin": true,
          "isSSPRole": false,
          "agentPermissionsList": []
        }
      },
      error: {
        status: 404,
        data: {
          error: "Role Not Found",
          message: "No role exists with the specified ID"
        }
      }
    }
  }
];

export const userGroupapiendpoints = (token,tenantCode, myOrgName,baseUrl) => [
  {
    name: "Get Dashboard User Groups (v4)",
    path: `${baseUrl}/gateway/Dashboard/usergroup/v4`,
    methods: ["GET"],
    description: "Retrieve the list of user groups for the dashboard (v4).",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: [
          {
            "group": {
              "Proceed for Disabled": {
                "count": 0,
                "agentList": {
                  "Sanjay Kulkarni": {
                    "id": 77,
                    "count": 0
                  },
                  "Ashu Ash": {
                    "id": 156,
                    "count": 0
                  },
                  "Ragul L": {
                    "id": 160,
                    "count": 0
                  },
                  "sanj20212 Vizionsys123": {
                    "id": 18,
                    "count": 0
                  },
                  "Ash Ashwini": {
                    "id": 6,
                    "count": 0
                  }
                }
              }
            }
          }
          // ...more groups
        ]
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];

export const dashboardV3apiendpoints = (token,tenantCode, myOrgName,baseUrl) => [
  {
    name: "Get Dashboard Data (v3)",
    path: `${baseUrl}/gateway/Dashboard/v3`,
    methods: ["POST"],
    description: "Retrieve dashboard data (encrypted payload).",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: 'Authorization', value: `Bearer ${token}`, enabled: true }

    ],
    parameters: [],
    requestBody: {
      GroupIds: [
        1,

      ]
    },
    responses: {
      success: {
        status: 200,
        data: {
  "ticketStatus": {
    "newTicketCount": 2,
    "openTicketCount": 2035,
    "dataList": {
      "NewtoMe": {
        "id": 2,
        "count": 1429
      }
    }
  },
  "priority": {
    "P1": {
      "id": 1,
      "count": 922,
      "color": "#ec0909"
    }
  },
  "tickettype": {
    "Incident": {
      "id": 50,
      "count": 905
    }
  },
  "resolvedToday": 0,
  "dueToday": 1,
  "dueInWeek": 2,
  "overdue": 1287,
  "responseSlainpercentageToday": 0,
  "resolutionSlainpercentageToday": 0,
  "resolvedTodayPer": 0
}
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];

export const groupallapiendpoints = (token,tenantCode, myOrgName,baseUrl) => [
  {
    name: "Get Group List",
    path: `${baseUrl}/gateway/Group`,
    methods: ["GET"],
    description: "Retrieve the list of all groups for the tenant.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }

    ],
    parameters: [],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: [
  {
    "id": 1,
    "name": "1st Line",
    "ticketAssignWithin": null,
    "escalationEmailTo": null,
    "groupDescription": null,
    "ranking": 0,
    "isActive": true,
    "createdAt": "2024-01-10T09:01:22.445784",
    "updatedAt": "2025-05-08T07:15:52.868795",
    "userGroupList": [
      {
        "id": 618325,
        "userId": 106,
        "groupId": 1,
        "isDefault": false,
        "isActive": true,
        "agent": {
          "id": 106,
          "firstName": "Shammmmmmmiiiiiii",
          "lastName": "S",
          "userName": "sham5178",
          "agentTypeId": 0,
          "agentAvatarPath": null,
          "mobilePhone": "",
          "email": "",
          "isAdmin": false,
          "isActive": false,
          "roleId": 2,
          "appDeviceId": null,
          "webDeviceId": null,
          "language": "",
          "agentDescription": "",
          "accountStatus": "New",
          "createdAt": "2024-10-17T10:18:34.318659",
          "updatedAt": "2024-10-17T10:18:34.318659",
          "isTwoFactorEnabled": false,
          "isTwoFactorSetupCompleted": false,
          "agentAvatarId": 0,
          "licenseKeyId": null,
          "agentPreferences": null,
          "userGroupList": null,
          "password": null,
          "roles": null,
          "agentLoginSession": null
        }
      }
    ]
  }

          // ...additional group objects
] 
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];


export const groupByIdapiendpoints =(token,tenantCode,baseUrl, myOrgName) => [
  {
    name: "Get Group By ID",
    path: `${baseUrl}/gateway/Group/1`, // Use :id if dynamic
    methods: ["GET"],
    description: "Retrieve details of a single group by its ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
 ],
    parameters: [
      {
        name: "id",
        description: "Group ID (as a path parameter)",
        type: "number",
        required: true,
        example: 1
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
  "id": 1,
  "name": "1st Line",
  "ticketAssignWithin": null,
  "escalationEmailTo": null,
  "groupDescription": null,
  "ranking": 0,
  "isActive": true,
  "createdAt": "2024-01-10T09:01:22.445784",
  "updatedAt": "2025-05-08T07:15:52.868795",
  "userGroupList": [
    {
      "id": 618184,
      "userId": 78,
      "groupId": 1,
      "isDefault": false,
      "isActive": true,
      "agent": {
        "id": 78,
        "firstName": "Harsha",
        "lastName": "Patel",
        "userName": "hars8762",
        "agentTypeId": 0,
        "agentAvatarPath": null,
        "mobilePhone": "919916640814",
        "email": "harsha.patel@vizionsys.com",
        "isAdmin": false,
        "isActive": false,
        "roleId": 1,
        "appDeviceId": null,
        "webDeviceId": null,
        "language": "Kannada",
        "agentDescription": "",
        "accountStatus": "New",
        "createdAt": "2024-10-07T08:56:00.348726",
        "updatedAt": "2024-10-07T08:56:00.348726",
        "isTwoFactorEnabled": false,
        "isTwoFactorSetupCompleted": false,
        "agentAvatarId": 0,
        "licenseKeyId": null,
        "agentPreferences": null,
        "userGroupList": null,
        "password": null,
        "roles": null,
        "agentLoginSession": null
      }
    }
  ]
}
      },
      error: {
        status: 404,
        data: {
          error: "Group Not Found",
          message: "No group exists with the specified ID"
        }
      }
    }
  }
];


export const groupCreationapiendpoints =(token,tenantCode,baseUrl, myOrgName) =>  [
  {
    name: "Create Group",
    path: `${baseUrl}/gateway/Group`,
    methods: ["POST"],
    description: "Create a new group (payload must be encrypted, text/plain).",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
  ],
    parameters: [],
    requestBody: {
      name: "Testing group postman",
      groupDescription: "Testing group postman",
      ranking: 999,
      isActive: true,
      createdAt: "2025-07-16T10:35:02.325Z",
      updatedAt: "2025-07-16T10:35:02.325Z"
    },
    responses: {
      success: {
        status: 200,
        data: {
          id: 49,
          name: "Testing group postman",
          ticketAssignWithin: null,
          escalationEmailTo: null,
          groupDescription: "Testing group postman",
          ranking: 999,
          isActive: true,
          createdAt: "2025-07-17T10:44:37.7349927Z",
          updatedAt: "2025-07-17T10:44:37.7513173Z",
          userGroupList: null
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body is missing required fields or not encrypted"
        }
      }
    }
  }
];



export const groupSoftDeleteapiendpoints =(token,tenantCode, baseUrl,myOrgName) => [
  {
    name: "Soft Delete Group (Change Status by IDs)",
    path: `${baseUrl}/gateway/Group/status/change?ids=48`,
    methods: ["DELETE"],
    description: "Soft delete (deactivate) one or more groups by ID; specify one or more IDs as query parameters.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
          { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
 ],
    parameters: [
      {
        name: "ids",
        description: "Comma-separated list of group IDs to (soft) delete",
        type: "string",
        required: true,
        example: "48"
      }
    ],
    queryParameters: [
      {
        name: "ids",
        description: "Comma-separated list of group IDs to (soft) delete",
        type: "string",
        required: true,
        example: "48"
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          message: "Groups status updated successfully",
          updatedIds: [48]
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid IDs",
          message: "One or more group IDs are invalid or not found"
        }
      }
    }
  }
];

export const updateGroupByIDapiendpoints =(token,tenantCode,  baseUrl,myOrgName)=> [
  {
    name: "Update Group By ID",
    path: `${baseUrl}/gateway/Group/48`, // (Use :id as a placeholder if dynamic)
    methods: ["PUT"],
    description: "Update an existing group by its ID. Payload must be encrypted and sent as text/plain.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
 ],
    parameters: [
      {
        name: "id",
        description: "Group ID (as a path parameter)",
        type: "number",
        required: true,
        example: 48
      }
    ],
    requestBody: {
  "id": 48,
  "name": "Testing group postman2",
  "ticketAssignWithin": null,
  "escalationEmailTo": null,
  "groupDescription": "Testing group postman",
  "ranking": 999,
  "isActive": true,
  "createdAt": "2025-07-16T10:36:35.818651",
  "updatedAt": "2025-07-18T05:29:35.1539543Z",
  "userGroupList": null
},
    responses: {
      success: {
        status: 200,
        data: {
          id: 48,
          name: "Testing group postman",
          ticketAssignWithin: null,
          escalationEmailTo: null,
          groupDescription: "Testing group postman",
          ranking: 999,
          isActive: true,
          createdAt: "2025-07-17T10:44:37.7349927Z",
          updatedAt: "2025-07-18T12:00:00.000Z",
          userGroupList: null
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body is missing required fields or not encrypted"
        }
      }
    }
  }
];

export const getRoleListapiendpoints =(token,tenantCode,  baseUrl,myOrgName)=> [
  {
    name: "Get Role List",
    path: `${baseUrl}/gateway/Role`,
    methods: ["GET"],
    description: "Retrieve the list of all roles for the tenant.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
   ],
    parameters: [],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: [
          {
            roleId: 1,
            name: "Admin",
            isActive: true,
            permissions: [
              "MANAGE_USERS",
              "VIEW_REPORTS"
            ]
          },
          {
            roleId: 2,
            name: "Support",
            isActive: true,
            permissions: [
              "HANDLE_TICKETS"
            ]
          }
          // ...additional role objects
        ]
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];


export const getRoleByIdapiendpoints =(token,tenantCode,  baseUrl,myOrgName)=> [
  {
    name: "Get Role By ID",
    path: `${baseUrl}/gateway/Role/1`, // Use /Role/:id for dynamic
    methods: ["GET"],
    description: "Retrieve details for a specific role by its ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
        { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
   ],
    parameters: [
      {
        name: "id",
        description: "Role ID (as a path parameter)",
        type: "number",
        required: true,
        example: 1
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          roleId: 1,
          name: "Admin",
          isActive: true,
          description: "Administrator role",
          permissions: [
            "MANAGE_USERS",
            "VIEW_REPORTS"
          ]
        }
      },
      error: {
        status: 404,
        data: {
          error: "Role Not Found",
          message: "No role exists with the specified ID"
        }
      }
    }
  }
];


export const createRoleapiendpoints =(token,tenantCode, baseUrl, myOrgName)=> [
  {
    name: "Create Role",
    path: `${baseUrl}/gateway/Role`,
    methods: ["POST"],
    description: "Create a new role (payload must be encrypted, text/plain).",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
         { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody: {
      name: "QA",
      description: "Quality assurance role",
      permissions: ["TEST_FEATURES", "VIEW_BUGS"],
      isActive: true,
      createdAt: "2025-07-18T15:00:00.000Z"
    },
    responses: {
      success: {
        status: 200,
        data: {
          roleId: 5,
          name: "QA",
          description: "Quality assurance role",
          permissions: [
            "TEST_FEATURES",
            "VIEW_BUGS"
          ],
          isActive: true,
          createdAt: "2025-07-18T15:00:00.000Z"
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body is missing required fields or not encrypted"
        }
      }
    }
  }
];


export const updateRoleapiendpoints =(token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Update Role By ID",
    path: `${baseUrl}/gateway/Role/59`, // (Use :id as a placeholder if dynamic)
    methods: ["PUT"],
    description: "Update a specific role by its ID. Payload must be encrypted and sent as text/plain.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
     ],
    queryParameters: 
      {
        name: "id",
        description: "Role ID (as a path parameter)",
        type: "number",
        required: true,
        example: 59
      }
    ,
    requestBody: {
  id: "59",
  name: "Test",
  description: "test",
  isActive: true,
  isSuperAdmin: false,
  isSSPRole: false,
  agentPermissionsList: [
    {
      "adminTypeId": 35,
      "adminChildIdLeavel1": null,
      "adminChildIdLeavel2": null,
      "adminChildIdLeavel3": null,
      "adminChildIdLeavel4": null,
      "permissionId": 1,
      "isActive": true,
      "isContact": false,
      "isAgentAdmin": false,
      "isSystemAdmin": true
    }
  ]
},
    responses: {
      success: {
        status: 200,
        data: {
          roleId: 59,
          name: "QA Engineer",
          description: "Updated QA role",
          permissions: [
            "RUN_TESTS",
            "REPORT_BUGS"
          ],
          isActive: true,
          createdAt: "2025-07-10T09:55:00.000Z",
          updatedAt: "2025-07-18T17:20:00.000Z"
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body is missing required fields or not encrypted"
        }
      }
    }
  }
];


export const deleteRolesapiendpoints =(token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Soft Delete Roles",
    path: `${baseUrl}/gateway/Role/soft/bulk/delete?ids=1&status=false`,
    methods: ["DELETE"],
    description: "Soft delete (deactivate) one or more roles by specifying their IDs and desired status in the query parameters.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "ids",
        description: "Comma-separated list of role IDs to update",
        type: "string",
        required: true,
        example: "1,2,3"
      },
      {
        name: "status",
        description: "Target status for the roles (usually 'false' to deactivate/soft delete)",
        type: "boolean",
        required: true,
        example: "false"
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          message: "Roles updated successfully",
          updatedIds: [1]
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid IDs or status",
          message: "Invalid or missing role IDs or status"
        }
      }
    }
  }
];


export const getAllAgentapiendpoints = (token,tenantCode, baseUrl, myOrgName) =>[
  {
    name: "Get Agent List",
    path: `${baseUrl}/gateway/Agent`,
    methods: ["GET"],
    description: "Retrieve a list of all agents for the tenant.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
     ],
    parameters: [],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: [
          {
            agentId: 101,
            firstName: "Jane",
            lastName: "Doe",
            email: "jane.doe@company.com",
            isActive: true,
            roles: ["Support", "Admin"]
          },
          {
            agentId: 102,
            firstName: "John",
            lastName: "Smith",
            email: "john.smith@company.com",
            isActive: false,
            roles: ["Support"]
          }
          // ... more agents
        ]
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];


export const getAgentByIdApiendpoints =(token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Agent By ID",
    path: `${baseUrl}/gateway/Agent/1`, // Use /Agent/:id for dynamic path
    methods: ["GET"],
    description: "Retrieve details for a specific agent by their ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
     ],
    parameters: [
      {
        name: "id",
        description: "Agent ID (as a path parameter)",
        type: "number",
        required: true,
        example: 1
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          agentId: 1,
          firstName: "Jane",
          lastName: "Doe",
          email: "jane.doe@company.com",
          isActive: true,
          roles: ["Support", "Admin"],
          mobile: "+1234567890"
        }
      },
      error: {
        status: 404,
        data: {
          error: "Agent Not Found",
          message: "No agent exists with the specified ID"
        }
      }
    }
  }
];

export const CreateAgentapiendpoints =(token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Create Agent",
    path: `${baseUrl}/gateway/Agent`,
    methods: ["POST"],
    description: "Create a new agent (request body must be encrypted and sent as text/plain).",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody:  {
  "firstName": "Test ",
  "lastName": "postman",
  "userName": "",
  "agentTypeId": 0,
  "mobilePhone": "",
  "email": "",
  "isAdmin": false,
  "roleId": 38,
  "language": "",
  "licenseKeyId": null,
  "agentDescription": "postman",
  "agentAvatarId": 0,
  "isTwoFactorEnabled": false,
  "userGroupList": [
    {
      "groupId": 1,
      "isDefault": false
    },
    {
      "groupId": 2,
      "isDefault": true
    },
    {
      "groupId": 10,
      "isDefault": false
    }
  ],
  "password": {
    "passwordHash": "123456"
  }
},
    responses: {
      success: {
        status: 200,
        data: {
          agentId: 103,
          firstName: "Jane",
          lastName: "Williams",
          email: "jane.williams@company.com",
          mobile: "+1234567890",
          roles: ["Support"],
          isActive: true,
          createdAt: "2025-07-18T15:00:00.000Z"
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body missing required fields or not encrypted"
        }
      }
    }
  }
];


export const updateAgentapiendpoints =(token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Update Agent By ID",
    path: `${baseUrl}/gateway/Agent/5`, // Use /Agent/:id for dynamic
    methods: ["PUT"],
    description: "Update an agent by ID (payload must be encrypted, text/plain).",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "id",
        description: "Agent ID (as a path parameter)",
        type: "number",
        required: true,
        example: 5
      }
    ],
    requestBody: {
  "id": 5,
  "firstName": "Peter",
  "lastName": "Lench",
  "userName": "pete2056",
  "agentTypeId": 0,
  "agentAvatarPath": `${baseUrl}/gateway/imagedetails/vizionsys/PLLinkedIN2.png`,
  "mobilePhone": "07879 443790",
  "email": "peter.lench@simplisys.com",
  "isAdmin": false,
  "isActive": true,
  "roleId": 4,
  "appDeviceId": null,
  "webDeviceId": "fIiyw-KdI5A-LKlR-W1vOh:APA91bGknRK3c8URmQ8bdmDYnuepTFrOAgH_oqW0KXkmH_qFwqTtl1r_JvAPDRwUQ8o8Ab_7pRF8TMolE_Mur-56CQGzbl6fXS0lcqMHswcMqtCpEuQOn8s",
  "language": null,
  "agentDescription": null,
  "accountStatus": "Completed",
  "createdAt": "2025-01-03T07:51:16.563104",
  "updatedAt": "2025-06-02T11:15:32.846303",
  "isTwoFactorEnabled": false,
  "isTwoFactorSetupCompleted": false,
  "agentAvatarId": 0,
  "licenseKeyId": 6,
  "agentPreferences": "{\"theme\": \"light-mode\",\"view\": \"Status\"}",
  "userGroupList": [
    {
      "groupId": 4,
      "isDefault": true
    },
    {
      "groupId": 7,
      "isDefault": false
    },
    {
      "groupId": 10,
      "isDefault": false
    }
  ],
  "roles": null,
  "agentLoginSession": null,
  "profilePicturePath": `${baseUrl}/gateway/imagedetails/vizionsys/PLLinkedIN2.png`
},
    responses: {
      success: {
        status: 200,
        data: {
  "id": 165,
  "firstName": "Test ",
  "lastName": "postman",
  "userName": "Test9819",
  "agentTypeId": 0,
  "agentAvatarPath": null,
  "mobilePhone": "",
  "email": "",
  "isAdmin": false,
  "isActive": false,
  "roleId": 38,
  "appDeviceId": null,
  "webDeviceId": null,
  "language": "",
  "agentDescription": "postman",
  "accountStatus": "New",
  "createdAt": "2025-07-18T09:28:10.6872129Z",
  "updatedAt": "2025-07-18T09:28:10.6872129Z",
  "isTwoFactorEnabled": false,
  "isTwoFactorSetupCompleted": false,
  "agentAvatarId": 0,
  "licenseKeyId": null,
  "agentPreferences": null,
  "userGroupList": [
    {
      "id": 620377,
      "userId": 165,
      "groupId": 1,
      "isDefault": false,
      "isActive": true,
      "agent": null
    },
    {
      "id": 620378,
      "userId": 165,
      "groupId": 2,
      "isDefault": true,
      "isActive": true,
      "agent": null
    },
    {
      "id": 620379,
      "userId": 165,
      "groupId": 10,
      "isDefault": false,
      "isActive": true,
      "agent": null
    }
  ],
  "password": {
    "id": 830,
    "passwordHash": "123456",
    "createdAt": "2025-07-18T09:28:10.6892162Z"
  },
  "roles": null,
  "agentLoginSession": null
}
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body missing required fields or not encrypted"
        }
      }
    }
  }
];


export const SoftDeleteapiendpoints =(token,tenantCode, baseUrl, myOrgName) =>  [
  {
    name: "Change Agent Status (Soft Delete)",
    path: `${baseUrl}/gateway/Agent/status/change?id=160&status=false`,
    methods: ["DELETE"],
    description: "Change the status (activate/deactivate) of an agent by ID via query parameters.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "id",
        description: "Agent ID (query parameter)",
        type: "number",
        required: true,
        example: 160
      },
      {
        name: "status",
        description: "Target status, e.g., false for deactivate (query parameter)",
        type: "boolean",
        required: true,
        example: false
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          message: "Agent status updated successfully",
          updatedId: 160,
          newStatus: false
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Parameters",
          message: "Agent ID or status is invalid or missing"
        }
      }
    }
  }
];

export const TicketTypeapiendpoints =(token,tenantCode, baseUrl, myOrgName) =>  [
  {
    name: "Get Ticket Type List",
    path: `${baseUrl}/gateway/TicketType`,
    methods: ["GET"],
    description: "Retrieve the list of all ticket types for the tenant.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: [
          {
            ticketTypeId: 1,
            name: "Incident",
            description: "User-submitted incidents",
            isActive: true
          },
          {
            ticketTypeId: 2,
            name: "Request",
            description: "Service requests",
            isActive: true
          }
          // ...more ticket types
        ]
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];

export const TicketTypByIdapiendpoints =(token,tenantCode, baseUrl, myOrgName) =>  [
  {
    name: "Get Ticket Type By ID",
    path: `${baseUrl}/gateway/TicketType/50`, // Use /TicketType/:id for dynamic
    methods: ["POST"],
    description: "Retrieve details for a specific ticket type by its ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
        { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
   ],
    parameters: [
      {
        name: "ticketTypeId",
        description: "Ticket type ID (as a path parameter)",
        type: "number",
        required: true,
        example: 50
      }
    ],
    requestBody: {
  "name": "Incident",
  "displayName": "Incident34",
  "description": null
},
    responses: {
      success: {
        status: 200,
        data: {
          ticketTypeId: 50,
          name: "Task",
          description: "A task ticket type",
          isActive: true
        }
      },
      error: {
        status: 404,
        data: {
          error: "Ticket Type Not Found",
          message: "No ticket type exists with the specified ID"
        }
      }
    }
  }
];

export const TicketTypeupdateapiendpoints =(token,tenantCode, baseUrl, myOrgName) =>  [
  {
    name: "Update Ticket Type By ID",
    path: `${baseUrl}/gateway/TicketType/50`, // Use /TicketType/:id for dynamic
    methods: ["PUT"],
    description: "Update a specific ticket type by ID (payload must be encrypted and sent as text/plain).",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
       { key: 'Authorization', value: `Bearer ${token}`, enabled: true }
     ],
    parameters: [
      {
        name: "ticketTypeId",
        description: "Ticket type ID (as a path parameter)",
        type: "number",
        required: true,
        example: 50
      }
    ],
    requestBody: {
  "name": "Incident",
  "displayName": "Incident34",
  "description": null
},
    responses: {
      success: {
        status: 200,
        data: {
          ticketTypeId: 50,
          name: "Task",
          description: "Task ticket type updated",
          isActive: true,
          updatedAt: "2025-07-18T16:10:00.000Z"
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body is missing required fields or not encrypted"
        }
      }
    }
  }
];


export const getCategoryListApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Category List V2",
    path: `${baseUrl}/gateway/Category/v2?page=1&count=50&isActive=true`,
    methods: ["GET"],
    description: "Retrieve a paginated and filtered list of active categories.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "page",
        description: "Page number for pagination",
        type: "number",
        required: false,
        example: 1
      },
      {
        name: "count",
        description: "Number of items per page",
        type: "number",
        required: false,
        example: 50
      },
      {
        name: "isActive",
        description: "Filter by active categories",
        type: "boolean",
        required: false,
        example: true
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        // Example response truncated for brevity
        data: {
          items: [
            {
              categoryId: 1,
              name: "Category 1",
              isActive: true,
              description: "Example category description"
            },
            // more categories...
          ],
          pagination: {
            page: 1,
            count: 50,
            totalItems: 150,
            totalPages: 3
          }
        }
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];
export const getCategoryByIdApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Category By ID",
    path: `${baseUrl}/gateway/Category/58`,
    methods: ["GET"],
    description: "Retrieve details for a specific category by its ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "categoryId",
        description: "Category ID (as a path parameter)",
        type: "number",
        required: true,
        example: 58
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          categoryId: 58,
          name: "Sample Category",
          isActive: true,
          description: "Description of the sample category"
        }
      },
      error: {
        status: 404,
        data: {
          error: "Not Found",
          message: "No category found with the specified ID"
        }
      }
    }
  }
];
export const updateCategoryApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Update Category By ID",
    path: `${baseUrl}/gateway/Category/58`,
    methods: ["PUT"],
    description: "Update a specific category by its ID. Payload must be encrypted and sent as text/plain.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "categoryId",
        description: "Category ID as a path parameter",
        type: "number",
        required: true,
        example: 58
      }
    ],
    requestBody: "Encrypted JSON payload as text/plain",
    decryptedBodyExample: {
      name: "Updated Category Name",
      description: "Updated description for the category",
      isActive: true,
      updatedAt: "2025-07-18T16:10:00.000Z"
    },
    responses: {
      success: {
        status: 200,
        data: {
          categoryId: 58,
          name: "Updated Category Name",
          description: "Updated description for the category",
          isActive: true,
          updatedAt: "2025-07-18T16:10:00.000Z"
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body is missing required fields or not encrypted"
        }
      }
    }
  }
];
export const deleteCategoryApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Delete Category By ID",
    path: `${baseUrl}/gateway/Category/2956`,
    methods: ["DELETE"],
    description: "Delete a category by its ID (hard delete).",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "categoryId",
        description: "ID of the category to delete (path parameter)",
        type: "number",
        required: true,
        example: 2956
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          message: "Category deleted successfully",
          deletedId: 2956
        }
      },
      error: {
        status: 404,
        data: {
          error: "Not Found",
          message: "Category with specified ID does not exist"
        }
      },
      unauthorized: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];

export const getPriorityListApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Priority List",
    path: `${baseUrl}/gateway/Priority`,
    methods: ["GET"],
    description: "Retrieve the list of all available priorities for the tenant.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: [
          {
            priorityId: 1,
            name: "High",
            description: "High priority tickets",
            ranking: 1,
            isActive: true
          },
          {
            priorityId: 2,
            name: "Medium",
            description: "Medium priority tickets",
            ranking: 2,
            isActive: true
          },
          {
            priorityId: 3,
            name: "Low",
            description: "Low priority tickets",
            ranking: 3,
            isActive: true
          }
          // ... more priority objects
        ]
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];

export const createPriorityApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Create Priority",
    path: `${baseUrl}/gateway/Priority`,
    methods: ["POST"],
    description: "Create a new priority entry. The request body must be encrypted and sent as text/plain.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody: "Encrypted JSON payload as text/plain",
    decryptedBodyExample: {
      name: "High",
      description: "High priority for urgent tickets",
      ranking: 1,
      isActive: true
    },
    responses: {
      success: {
        status: 200,
        data: {
          priorityId: 101,
          name: "High",
          description: "High priority for urgent tickets",
          ranking: 1,
          isActive: true
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body missing required fields or not properly encrypted"
        }
      }
    }
  }
];
export const getPriorityByIdApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Priority By ID",
    path: `${baseUrl}/gateway/Priority/1`,
    methods: ["GET"],
    description: "Retrieve details for a specific priority by its ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "priorityId",
        description: "Priority ID (path parameter)",
        type: "number",
        required: true,
        example: 1
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          priorityId: 1,
          name: "High",
          description: "High priority for urgent tickets",
          ranking: 1,
          isActive: true
        }
      },
      error: {
        status: 404,
        data: {
          error: "Not Found",
          message: "Priority with specified ID does not exist"
        }
      }
    }
  }
];
export const updatePriorityApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Update Priority By ID",
    path: `${baseUrl}/gateway/Priority/68`,
    methods: ["PUT"],
    description: "Update a specific priority by its ID with an encrypted payload (sent as text/plain).",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "priorityId",
        description: "Priority ID (path parameter)",
        type: "number",
        required: true,
        example: 68
      }
    ],
    requestBody: "Encrypted JSON payload sent as text/plain",
    decryptedBodyExample: {
      name: "Urgent",
      description: "Urgent priority for critical tickets",
      ranking: 1,
      isActive: true,
      updatedAt: "2025-07-18T16:10:00.000Z"
    },
    responses: {
      success: {
        status: 200,
        data: {
          priorityId: 68,
          name: "Urgent",
          description: "Urgent priority for critical tickets",
          ranking: 1,
          isActive: true,
          updatedAt: "2025-07-18T16:10:00.000Z"
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body missing required fields or not encrypted properly"
        }
      }
    }
  }
];
export const deletePriorityApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Delete Priority By ID",
    path: `${baseUrl}/gateway/Priority/68`,
    methods: ["DELETE"],
    description: "Delete a priority by its ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "priorityId",
        description: "ID of the priority to delete",
        type: "number",
        required: true,
        example: 68
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          message: "Priority deleted successfully",
          deletedId: 68
        }
      },
      error: {
        status: 404,
        data: {
          error: "Not Found",
          message: "Priority with specified ID does not exist"
        }
      },
      unauthorized: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];


export const getWorkingTimePlanApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Working Time Plan List",
    path: `${baseUrl}/gateway/WorkingTimePlan`,
    methods: ["GET"],
    description: "Retrieve the list of all working time plans for the tenant.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: [
          {
            planId: 1,
            name: "Standard 9-5",
            description: "Standard working hours from 9 AM to 5 PM",
            isActive: true,
            workingDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            startTime: "09:00",
            endTime: "17:00"
          },
          {
            planId: 2,
            name: "Flexible",
            description: "Flexible working hours",
            isActive: true,
            workingDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            startTime: "08:00",
            endTime: "18:00"
          }
          // ... more working time plans
        ]
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];

export const getWorkingTimePlanByIdApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Working Time Plan By ID",
    path: `${baseUrl}/gateway/WorkingTimePlan/1`,
    methods: ["GET"],
    description: "Retrieve details of a specific working time plan by its ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "planId",
        description: "Working Time Plan ID (path parameter)",
        type: "number",
        required: true,
        example: 1
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          planId: 1,
          name: "Standard 9-5",
          description: "Standard working hours from 9 AM to 5 PM",
          isActive: true,
          workingDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          startTime: "09:00",
          endTime: "17:00"
        }
      },
      error: {
        status: 404,
        data: {
          error: "Not Found",
          message: "Working time plan with specified ID does not exist"
        }
      }
    }
  }
];
export const updateWorkingTimePlanApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Update Working Time Plan By ID",
    path: `${baseUrl}/gateway/WorkingTimePlan/1`,
    methods: ["PUT"],
    description: "Update the working time plan identified by ID with encrypted JSON payload sent as text/plain.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "planId",
        description: "Working Time Plan ID (path parameter)",
        type: "number",
        required: true,
        example: 1
      }
    ],
    requestBody: "Encrypted JSON payload as text/plain",
    decryptedBodyExample: {
      name: "Standard 9-5 Updated",
      description: "Updated standard working hours",
      isActive: true,
      workingDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      startTime: "09:00",
      endTime: "17:00",
      updatedAt: "2025-07-18T16:10:00.000Z"
    },
    responses: {
      success: {
        status: 200,
        data: {
          planId: 1,
          name: "Standard 9-5 Updated",
          description: "Updated standard working hours",
          isActive: true,
          workingDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          startTime: "09:00",
          endTime: "17:00",
          updatedAt: "2025-07-18T16:10:00.000Z"
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body missing required fields or not encrypted"
        }
      }
    }
  }
];
export const createWorkingTimePlanApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Create Working Time Plan",
    path: `${baseUrl}/gateway/WorkingTimePlan`,
    methods: ["POST"],
    description: "Create a new working time plan with an encrypted payload (sent as text/plain).",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody: "Encrypted JSON payload as text/plain",
    decryptedBodyExample: {
      name: "New Flexible Plan",
      description: "Flexible working hours plan",
      isActive: true,
      workingDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      startTime: "08:00",
      endTime: "18:00"
    },
    responses: {
      success: {
        status: 201,
        data: {
          planId: 123,
          name: "New Flexible Plan",
          description: "Flexible working hours plan",
          isActive: true,
          workingDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          startTime: "08:00",
          endTime: "18:00"
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Missing required fields or payload not encrypted"
        }
      }
    }
  }
];
export const deleteWorkingTimePlanApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Delete Working Time Plan By ID",
    path: `${baseUrl}/gateway/WorkingTimePlan/24`,
    methods: ["DELETE"],
    description: "Delete a working time plan identified by its ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "planId",
        description: "ID of the working time plan to delete",
        type: "number",
        required: true,
        example: 24
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          message: "Working time plan deleted successfully",
          deletedId: 24
        }
      },
      error: {
        status: 404,
        data: {
          error: "Not Found",
          message: "Working time plan with specified ID does not exist"
        }
      },
      unauthorized: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];

export const getTicketStatusListApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Ticket Status List",
    path: `${baseUrl}/gateway/TicketStatus`,
    methods: ["GET"],
    description: "Retrieve the list of all ticket statuses for the tenant.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: [
          {
            statusId: 1,
            name: "Open",
            description: "Ticket is open",
            isActive: true
          },
          {
            statusId: 2,
            name: "In Progress",
            description: "Ticket is being worked on",
            isActive: true
          },
          {
            statusId: 3,
            name: "Resolved",
            description: "Ticket issue resolved",
            isActive: true
          },
          {
            statusId: 4,
            name: "Closed",
            description: "Ticket closed",
            isActive: true
          }
          // ...more statuses
        ]
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];
export const getTicketStatusWithBodyApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Ticket Status List (with body)",
    path: `${baseUrl}/gateway/TicketStatus`,
    methods: ["GET"],
    description: "Retrieve the list of all ticket statuses for the tenant. This unusual GET request expects a text/plain body.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody: "Plain text encrypted payload",
    responses: {
      success: {
        status: 200,
        data: [
          /* expected ticket status objects here, similar to standard GET */
        ]
      },
      error: {
        status: 400,
        data: {
          error: "Bad Request",
          message: "Invalid request body or method"
        }
      }
    }
  }
];

export const createTicketStatusApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Create Ticket Status",
    path: `${baseUrl}/gateway/TicketStatus`,
    methods: ["POST"],
    description: "Create a new ticket status. Request body must be encrypted and sent as text/plain.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody: "Encrypted JSON payload as text/plain",
    decryptedBodyExample: {
      name: "New Status",
      description: "Description of new status",
      isActive: true
    },
    responses: {
      success: {
        status: 201,
        data: {
          statusId: 123,
          name: "New Status",
          description: "Description of new status",
          isActive: true
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body missing required fields or not properly encrypted"
        }
      }
    }
  }
];

export const getContactsApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Contacts List",
    path: `${baseUrl}/gateway/Contacts`,
    methods: ["GET"],
    description: "Retrieve a paginated list of contacts. Supports filtering by active status.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      { name: "page", type: "number", required: false, example: 1, description: "Page number (pagination)" },
      { name: "count", type: "number", required: false, example: 50, description: "Number of items per page" },
      { name: "isActive", type: "boolean", required: false, example: true, description: "Filter for active contacts" }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          "total": 1250,
          "page": 1,
          "count": 50,
          "contacts": [
            {
              "contactId": 101,
              "name": "John Doe",
              "email": "john.doe@example.com",
              "phone": "+911234567890",
              "isActive": true
            },
            {
              "contactId": 102,
              "name": "Jane Smith",
              "email": "jane.smith@example.com",
              "phone": "+911234567891",
              "isActive": true
            }
            //...more contacts
          ]
        }
      },
      error: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];
export const createContactApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Create Contact",
    path: `${baseUrl}/gateway/Contacts`,
    methods: ["POST"],
    description: "Create a new contact. The request body must be encrypted and sent as text/plain.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [],
    requestBody: "Encrypted JSON payload as text/plain",
    decryptedBodyExample: {
      name: "John Doe",
      email: "john.doe@example.com",
      phone: "+911234567890",
      isActive: true
    },
    responses: {
      success: {
        status: 201,
        data: {
          contactId: 201,
          name: "John Doe",
          email: "john.doe@example.com",
          phone: "+911234567890",
          isActive: true
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body missing required fields or not properly encrypted"
        }
      }
    }
  }
];
export const getContactByIdApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Contact By ID",
    path: `${baseUrl}/gateway/Contacts/258102`,
    methods: ["GET"],
    description: "Retrieve a specific contact by its unique contact ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "contactId",
        description: "Unique ID of the contact (path parameter)",
        type: "number",
        required: true,
        example: 258102
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          contactId: 258102,
          name: "John Doe",
          email: "john.doe@example.com",
          phone: "+911234567890",
          isActive: true
        }
      },
      error: {
        status: 404,
        data: {
          error: "Not Found",
          message: "Contact with specified ID does not exist"
        }
      }
    }
  }
];

export const updateContactByIdApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Update Contact By ID",
    path: `${baseUrl}/gateway/Contacts/258102`,
    methods: ["PUT"],
    description: "Update a specific contact by its ID. The request body must be an encrypted JSON payload sent as text/plain.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "contactId",
        description: "Unique ID of the contact (path parameter)",
        type: "number",
        required: true,
        example: 258102
      }
    ],
    requestBody: "Encrypted JSON payload as text/plain",
    decryptedBodyExample: {
      name: "Jane Smith",
      email: "jane.smith@example.com",
      phone: "+911234567891",
      isActive: true
    },
    responses: {
      success: {
        status: 200,
        data: {
          contactId: 258102,
          name: "Jane Smith",
          email: "jane.smith@example.com",
          phone: "+911234567891",
          isActive: true
        }
      },
      error: {
        status: 400,
        data: {
          error: "Invalid Payload",
          message: "Request body missing required fields or not properly encrypted"
        }
      }
    }
  }
];

export const changeContactStatusApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Change Contact Status By ID (Bulk Deactivate/Activate)",
    path: `${baseUrl}/gateway/Contacts/status/change?ids=258102&status=false`,
    methods: ["DELETE"],
    description: "Change (activate/deactivate) the status of one or more contacts by ID using a bulk operation.",
    headers: [
      { key: "Tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "ids",
        description: "Comma separated list of contact IDs to update",
        type: "string",
        required: true,
        example: "258102,258103"
      },
      {
        name: "status",
        description: "Desired status (`true` to activate, `false` to deactivate)",
        type: "boolean",
        required: true,
        example: "false"
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          message: "Contact status updated successfully",
          updatedIds: [258102]
        }
      },
      error: {
        status: 400,
        data: {
          error: "Bad Request",
          message: "Invalid IDs or status"
        }
      },
      unauthorized: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      }
    }
  }
];

export const assetApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  // 1. Get Assets list
  {
    name: "Get Assets List",
    path: `${baseUrl}/gateway/Asset`,
    methods: ["GET"],
    description: "Retrieve a paginated list of assets, optionally filtered by active status.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      { name: "page", type: "number", required: false, example: 0, description: "Page number" },
      { name: "count", type: "number", required: false, example: 50, description: "Assets per page" },
      { name: "isActive", type: "boolean", required: false, example: true, description: "Filter by active status" }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          total: 500,
          page: 0,
          count: 50,
          assets: [
            /* example asset list items */
          ]
        }
      },
      error: {
        status: 401,
        data: { error: "Unauthorized", message: "Invalid or missing Bearer token" }
      }
    }
  },

  // 2. Get Asset by ID
  {
    name: "Get Asset By ID",
    path: `${baseUrl}/gateway/Asset/{assetId}`,
    methods: ["GET"],
    description: "Retrieve details of a specific asset by its ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      { name: "assetId", type: "number", required: true, example: 1, description: "ID of the asset" }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          assetId: 1,
          name: "Laptop Dell XPS 13",
          category: "Electronics",
          isActive: true,
          purchaseDate: "2023-05-10"
        }
      },
      error: {
        status: 404,
        data: { error: "Not Found", message: "Asset with specified ID does not exist" }
      }
    }
  },

  // 3. Create Asset
  {
    name: "Create Asset",
    path: `${baseUrl}/gateway/Asset`,
    methods: ["POST"],
    description: "Create a new asset by sending encrypted JSON payload as text/plain.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    requestBody: "Encrypted JSON payload as text/plain",
    decryptedBodyExample: {
      name: "Laptop Dell XPS 13",
      category: "Electronics",
      isActive: true,
      purchaseDate: "2023-05-10"
    },
    responses: {
      success: {
        status: 201,
        data: {
          assetId: 101,
          name: "Laptop Dell XPS 13",
          category: "Electronics",
          isActive: true,
          purchaseDate: "2023-05-10"
        }
      },
      error: {
        status: 400,
        data: { error: "Invalid Payload", message: "Request body missing required fields or not encrypted" }
      }
    }
  },

  // 4. Update Asset By ID
  {
    name: "Update Asset By ID",
    path: `${baseUrl}/gateway/Asset/{assetId}`,
    methods: ["PUT"],
    description: "Update an existing asset by ID with encrypted JSON payload as text/plain.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      { name: "assetId", type: "number", required: true, example: 1, description: "Asset ID to update" }
    ],
    requestBody: "Encrypted JSON payload as text/plain",
    decryptedBodyExample: {
      name: "Laptop Dell XPS 15",
      category: "Electronics",
      isActive: true,
      purchaseDate: "2023-08-01"
    },
    responses: {
      success: {
        status: 200,
        data: {
          assetId: 1,
          name: "Laptop Dell XPS 15",
          category: "Electronics",
          isActive: true,
          purchaseDate: "2023-08-01"
        }
      },
      error: {
        status: 400,
        data: { error: "Invalid Payload", message: "Request body missing required fields or not encrypted" }
      }
    }
  },

  // 5. Soft Delete Asset(s) - Bulk Status Change (Activate/Deactivate)
  {
    name: "Change Asset Status (Activate/Deactivate)",
    path: `${baseUrl}/gateway/Asset/status/change`,
    methods: ["DELETE"],
    description: "Bulk activate or deactivate assets by comma separated IDs via query params.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      { name: "ids", type: "string", required: true, example: "234,235", description: "Comma-separated asset IDs" },
      { name: "status", type: "boolean", required: true, example: false, description: "true to activate, false to deactivate" }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          message: "Asset statuses updated successfully",
          updatedIds: [234, 235]
        }
      },
      error: {
        status: 400,
        data: { error: "Bad Request", message: "Invalid IDs or status" }
      }
    }
  }
];

export const createTicketApiEndpoint = (token,tenantCode, baseUrl, myOrgName) => [({
  name: "Create Ticket",
  path: `${baseUrl}/gateway/Ticket`,
  methods: ["POST"],
  description: "Create a new ticket by sending ticket details as an encrypted or plain payload.",
  headers: [
    { key: "tenant-code", value: tenantCode, enabled: true },
    { key: "Content-Type", value: "text/plain", enabled: true },
    { key: "Authorization", value: `Bearer ${token}`, enabled: true }
  ],
  parameters: [],
  requestBody: {
      id: 0,
      sourceCode: "Phone",
      ticketLogs: {
        contactId: 11,
        secondaryContactId: 0,
        priorityId: 1,
        title: "postman ticket",
        categoryId: 2168,
        ticketLogChangesList: [],
        priority: {
          id: 1,
          name: "P1",
          color: "#ec0909",
          ticketTypeList: [
            {
              id: 710,
              priorityId: 1,
              ticketTypeId: 51,
              ticketType: {
                id: 51,
                parentId: 1,
                name: "Service Request",
                displayName: "Service Request"
              }
            }
          ]
        },
        source: {
          id: 8,
          code: "Phone",
          displayName: "Phone",
          createdAt: "2024-01-10T09:01:22.445784",
          updatedAt: "2025-02-04T11:45:31.084551",
          isActive: true,
          label: "Phone",
          value: 8
        },
        ticketType: {
          id: 51,
          parentId: 1,
          name: "Service Request",
          displayName: "Service Request",
          description: null,
          isActive: true,
          json: null,
          label: "Service Request",
          value: 51
        },
        contacts: {
          label: "Amith. Malipatil,(malipatilamith404@gmail.com)",
          name: "Amith. Malipatil",
          value: "Amith. Malipatil",
          id: 11
        },
        secondaryContacts: null,
        groupId: 1,
        agentId: 1,
        statusId: 3,
        note: "",
        effort: "00:00:00",
        ticketLogAttachmentsList: [],
        circulationListTO: "malipatilamith404@gmail.com",
        circulationListBCC: null,
        circulationListCC: null,
        IsNotePrivate: false,
        group: {
          id: 1,
          name: "1st Line",
          ticketAssignWithin: null,
          escalationEmailTo: null,
          groupDescription: null,
          ranking: 0,
          isActive: true,
          createdAt: "2024-01-10T09:01:22.445784",
          updatedAt: "2025-05-08T07:15:52.868795",
          userGroupList: [
            {
              id: 618184,
              userId: 78,
              groupId: 1,
              isDefault: false,
              isActive: true,
              agent: {
                id: 78,
                firstName: "Harsha",
                lastName: "Patel",
                userName: "hars8762",
                agentTypeId: 0
              }
            }
          ],
          label: "1st Line",
          value: 1,
          agentsList: [
            {
              id: 77,
              firstName: "Sanjay",
              lastName: "Kulkarni",
              userName: "sanj2021",
              agentTypeId: 0,
              agentAvatarPath: `${baseUrl}/gateway/imagedetails/vizionsys/Agent/77/sanj2021.png`,
              mobilePhone: "6566467677676",
              email: "girish.kulkarni@vizionsys.com",
              isAdmin: false,
              isActive: true,
              language: "676777u756767676"
            }
          ]
        },
        ticketStatus: {
          id: 3,
          name: "InProgress",
          displayName: "In Progress",
          type: "TicketStatus",
          isActive: true,
          ranking: 999,
          label: "In Progress",
          value: 3
        },
        outComeCategoryId: null,
        agent: {
          id: 1,
          firstName: "Amith Malipatil (vizion123)",
          email: null
        },
        downtime: "00:00:00",
        thirdPartyRefNo: null,
        contactOrganisationId: 0
      },
      ticketAssetList: [],
      ticketRelationshipList: null,
      ticketTagList: null,
      ticketTaskList: [],
      totalEffort: "00:00:00"
    
  },
  responses: {
    success: {
      status: 201,
      data: {
        message: "Ticket successfully created or updated",
        ticketId: 1234
      }
    },
    error: {
      status: 400,
      data: {
        error: "Bad Request",
        message: "Invalid data or missing required fields"
      }
    },
    unauthorized: {
      status: 401,
      data: {
        error: "Unauthorized",
        message: "Invalid or missing authorization token"
      }
    }
  }
})];


export const updateTicketApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Update Ticket By ID",
    path: `${baseUrl}/gateway/Ticket/4454`,
    methods: ["PUT"],
    description: "Update an existing ticket by ticket ID with encrypted or plain JSON payload.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Content-Type", value: "text/plain", enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "id",
        description: "Ticket ID to update",
        type: "integer",
        required: true,
        example: 4454
      }
    ],
    requestBody:  {
  "id": 4454,
  "sourceCode": "Phone",
  "ticketLogs": {
    "id": 51894,
    "ticketId": 4454,
    // ticket log details...
    "circulationListTO": "malipatilamith404@gmail.com",
    "ticketStatus": {
      "id": 3,
      "name": "InProgress",
      "displayName": "In Progress"
    },
    "priority": {
      "id": 1,
      "name": "P1",
      "color": "#ec0909"
    },
    "ticketType": {
      "id": 51,
      "name": "Service Request"
    },
    "group": {
      "id": 1,
      "name": "1st Line"
    },
    "agent": {
      "id": 1,
      "firstName": "Amith Malipatil"
    },
    "contacts": {
      "label": "Amith. Malipatil,(malipatilamith404@gmail.com)"
    }
  },
  "ticketAssetList": [],
  "ticketRelationshipList": null,
  "ticketTagList": [],
  "ticketTaskList": [],
  "totalEffort": "00:00:00"
}
    ,
    responses: {
      success: {
        status: 200,
        data: {
          message: "Ticket updated successfully",
          ticketId: 4454
        }
      },
      error: {
        status: 400,
        data: {
          error: "Bad Request",
          message: "Invalid or missing fields in request body"
        }
      },
      unauthorized: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      },
      notFound: {
        status: 404,
        data: {
          error: "Not Found",
          message: "Ticket ID not found"
        }
      }
    }
  }
];


export const getTicketLogAttachmentsApiEndpoints = (token,tenantCode, baseUrl, myOrgName) => [
  {
    name: "Get Ticket Log Attachments By ID",
    path: `${baseUrl}/gateway/TicketLogAttachments/4466`,
    methods: ["GET"],
    description: "Retrieve ticket log attachments for a specific Ticket Log Attachment ID.",
    headers: [
      { key: "tenant-code", value: tenantCode, enabled: true },
      { key: "Authorization", value: `Bearer ${token}`, enabled: true }
    ],
    parameters: [
      {
        name: "id",
        description: "Ticket Log Attachment ID to fetch attachments for",
        type: "integer",
        required: true,
        example: 4455
      }
    ],
    requestBody: {},
    responses: {
      success: {
        status: 200,
        data: {
          message: "Ticket log attachments fetched successfully",
          attachments: [
            {
              attachmentId: 123,
              fileName: "screenshot.png",
              fileType: "image/png",
              url: `${baseUrl}/path/to/screenshot.png`
            }
          ]
        }
      },
      error: {
        status: 400,
        data: {
          error: "Bad Request",
          message: "Invalid or missing ID"
        }
      },
      unauthorized: {
        status: 401,
        data: {
          error: "Unauthorized",
          message: "Invalid or missing Bearer token"
        }
      },
      notFound: {
        status: 404,
        data: {
          error: "Not Found",
          message: "Ticket Log Attachment with specified ID not found"
        }
      }
    }
  }
];


export const getTicketTimelineApiEndpoint = (token,tenantCode, baseUrl, myOrgName) => [({
  name: "Get Ticket Timeline",
  path: `${baseUrl}/gateway/Ticket/timeline/{ticketId}`,
  methods: ["GET"],
  description: "Retrieve a paginated timeline of events for a specific ticket.",
  headers: [
    { key: "tenant-code", value: tenantCode, enabled: true },
    { key: "Authorization", value: `Bearer ${token}`, enabled: true }
  ],
  parameters: [
    { name: "ticketId", in: "path", required: true, type: "integer", description: "The Ticket ID to fetch timeline for." },
    { name: "page", in: "query", required: false, type: "integer", description: "Page number (default 0)." },
    { name: "count", in: "query", required: false, type: "integer", description: "Number of timeline items per page (default 10)." }
  ],
  requestBody: null,
  responses: {
    success: {
      status: 200,
      description: "Returns a paginated list of timeline events related to the ticket.",
      data: {
        totalCount: 123,
        timelineItems: [
          {
  "page": 0,
  "ticketId": 4455,
  "ticketLog": [
    {
      "id": 51915,
      "ticketId": 4455,
      "customId": null,
      "workflowNodeId": 0,
      "type": "Update",
      "title": "postman ticket",
      "note": "",
      "description": "postman ticket",
      "webformValues": null,
      "thirdPartyRefNo": null,
      "webformId": 0,
      "categoryId": 2168,
      "statusId": 5,
      "ticketTypeId": 51,
      "priorityId": 1,
      "urgency": 0,
      "outgoingSourceCode": null,
      "sourceCode": "Phone",
      "userType": "Agent",
      "sla": 0,
      "createdByUserId": 1,
      "isActive": true,
      "contactId": 11,
      "secondaryContactId": 0,
      "groupId": 1,
      "contactOrganisationId": 0,
      "agentId": 1,
      "managerId": 0,
      "outComeCategoryId": 0,
      "nextActionDescription": "",
      "from": null,
      "to": null,
      "circulationListTO": null,
      "cc": null,
      "circulationListCC": null,
      "bcc": null,
      "circulationListBCC": null,
      "body": null,
      "isMessageSuccess": true,
      "isNotePrivate": false,
      "user": null,
      "ticketLogAttachmentsList": [],
      "ticketLogChangesList": [
        {
          "id": 16308,
          "ticketLogId": 51915,
          "changes": "TO Changed From malipatilamith404@gmail.com To --"
        }
      ],
      "slaRemainingInTicks": -639712265890,
      "slaRemaining": "-17:46:11.2265890",
      "effortInTicks": 0,
      "effort": "00:00:00",
      "effortInMinutes": 0,
      "downtimeInTicks": 0,
      "downtime": "00:00:00",
      "ticketStatus": null,
      "priority": null,
      "ticketType": null,
      "group": null,
      "agent": {
        "id": 1,
        "firstName": "Amith",
        "lastName": "Malipatil",
        "userName": "vizion123",
        "agentTypeId": 0,
        "agentAvatarPath": `${baseUrl}/gateway/imagedetails/vizionsys/Agent/1/vizion123.jpg`,
        "mobilePhone": "",
        "email": null,
        "isAdmin": false,
        "isActive": true,
        "roleId": 1,
        "appDeviceId": null,
       "language": "",
        "agentDescription": null,
        "createdAt": "2025-07-23T10:16:11.2315199Z",
        "updatedAt": "2025-07-23T10:16:11.23152Z",
        "isTwoFactorEnabled": false,
        "roles": null,
        "fullName": "Amith Malipatil"
      },
      "contacts": null,
      "secondaryContacts": null,
      "manager": null,
      "contactOrganisation": null,
      "webform": null,
      "category": null,
      "outComeCategory": null
    }
  ],
  "totalEfforts": "00:00:00",
  "totalDownTime": "00:00:00",
  "slaRemaining": "-17:46:11.2265890"
}/* timeline event objects */
        ]
      }
    },
    error: {
      status: 401,
      description: "Unauthorized - Missing or invalid Bearer token.",
      data: {
        error: "Unauthorized",
        message: "Invalid or missing Bearer token"
      }
    }
  }
})];

export const updateTicketPriorityApiEndpoint = (token, tenantCode, myOrgName,baseUrl) => [({
  name: "Update Ticket Priority",
  path: `${baseUrl}/gateway/Ticket/update/priority/byticket/{ticketId}`,
  methods: ["POST"],
  description: "Update the priority of a specific ticket using the ticket ID and new priority ID.",
  headers: [
    { key: "tenant-code", value: tenantCode, enabled: true },
    { key: "Authorization", value: `Bearer ${token}`, enabled: true }
  ],
  parameters: [
    { name: "ticketId", in: "path", required: true, type: "integer", description: "The ID of the ticket to update." },
    { name: "priorityid", in: "query", required: true, type: "integer", description: "The new priority ID to set to the ticket." }
  ],
  requestBody: null,
  responses: {
    success: {
      status: 200,
      description: "Ticket priority updated successfully."
    },
    error: {
      status: 401,
      description: "Unauthorized - Missing or invalid Bearer token.",
      data: {
        error: "Unauthorized",
        message: "Invalid or missing Bearer token"
      }
    }
  },
})]
